const RELOAD_KEY = "chunk-reload-at";
const RELOAD_WINDOW_MS = 10_000;

// What browsers report when a lazy route chunk is gone, i.e. a deploy replaced the
// hashed file an already-open tab still points at (Chrome, Firefox, Safari, Vite CSS).
const CHUNK_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERROR.test(error.message);
}

// One automatic reload per window, so a chunk that is genuinely missing can't loop the page.
export function canAutoReload(
  storage: Pick<Storage, "getItem"> = sessionStorage,
  now: number = Date.now(),
): boolean {
  const last = Number(storage.getItem(RELOAD_KEY));
  return !last || now - last >= RELOAD_WINDOW_MS;
}

export function markAutoReload(
  storage: Pick<Storage, "setItem"> = sessionStorage,
  now: number = Date.now(),
): void {
  storage.setItem(RELOAD_KEY, String(now));
}
